// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"58eb595e","453":"370bfd65","455":"c8a56c94","977":"a776b00a"}[chunkId] + ".chunk.js";
};